class StickyNav {
  constructor() {
    this.$nav = null;
    this.$mobileMenu = null;
    this.navHeight = 0;
    this.headerHeight = 0;
    this.lastScrollY = 0;
    this.mobileMenuOpen = false;
    this.showStickyNav = false;
    this.rafId = null;
    this.resizeObserver = null;
    this.isMobile = window.innerWidth <= 900;
    
    document.addEventListener('DOMContentLoaded', e => this.init());
  }

  init() {
    this.$nav = document.querySelector('[data-sticky-nav-mobile]');
    this.$mobileMenu = document.querySelector('#menu-mobile');
    if(!this.$nav || !this.$mobileMenu) return;

    this.cacheDimensions();
    this.setupResizeObserver();
    this.setupScrollHandler();
  }

  cacheDimensions() {
    let header = document.querySelector('#shopify-section-header'),
        quickLinks = document.querySelector('#shopify-section-quicklinks');

    this.headerHeight = (header?.offsetHeight || 0) + (quickLinks?.offsetHeight || 0);
    this.navHeight = this.$nav.offsetHeight;
    this.lastScrollY = window.scrollY;
    this.isMobile = window.innerWidth <= 900;
  }

  setupResizeObserver() {
    // Use ResizeObserver to detect when header dimensions change
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.cacheDimensions();
      });
      
      const header = document.querySelector('#shopify-section-header');
      const quickLinks = document.querySelector('#shopify-section-quicklinks');
      
      if (header) this.resizeObserver.observe(header);
      if (quickLinks) this.resizeObserver.observe(quickLinks);
    }
  }

  setupScrollHandler() {
    this.scrollHandler = (e) => {
      // Cancel previous animation frame
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
      }
      
      this.rafId = requestAnimationFrame(() => {
        this.handleScroll();
      });
    };
    
    document.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  handleScroll() {
    if (!this.isMobile) {
      this.showStickyNav = false;
      this.updateNavVisibility();
      return;
    }

    this.mobileMenuOpen = !!document.querySelector('#menu-mobile.open');
    const currentScrollY = window.scrollY;

    // Check if we're scrolling up and past the header
    if (this.lastScrollY > currentScrollY && currentScrollY > this.headerHeight) {
      this.showStickyNav = true;
      this.updateMobileMenuPosition();
    } else if (!this.mobileMenuOpen && (this.lastScrollY < currentScrollY || currentScrollY < this.headerHeight)) {
      this.showStickyNav = false;
      this.resetMobileMenuPosition();
    }

    this.updateNavVisibility();
    this.lastScrollY = currentScrollY;
  }

  updateMobileMenuPosition() {
    // Use CSS transforms for better performance
    this.$mobileMenu.style.transform = `translateY(${this.navHeight - 90}px)`;
    this.$mobileMenu.style.paddingTop = `${this.navHeight - 54}px`;
  }

  resetMobileMenuPosition() {
    this.$mobileMenu.style.transform = '';
    this.$mobileMenu.style.paddingTop = '';
  }

  updateNavVisibility() {
    this.$nav.setAttribute('aria-hidden', !this.showStickyNav);
    
    // Use CSS classes for better performance than direct style manipulation
    if (this.showStickyNav) {
      this.$nav.classList.add('sticky-nav-active');
    } else {
      this.$nav.classList.remove('sticky-nav-active');
    }
  }

  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
    if (this.scrollHandler) {
      document.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

// Global instance management for proper cleanup
window.stickyNavInstance = null;

function initStickyNav() {
  // Destroy previous instance if it exists
  if (window.stickyNavInstance) {
    window.stickyNavInstance.destroy();
  }
  window.stickyNavInstance = new StickyNav();
}

// Initialize on page load
initStickyNav();

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector(`#${e.detail.sectionId}`)) {
      initStickyNav(); // Proper cleanup and reinit
    }
  });
  
  document.addEventListener('shopify:section:unload', e => {
    if (window.stickyNavInstance) {
      window.stickyNavInstance.destroy();
      window.stickyNavInstance = null;
    }
  });
}

